import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { disableStudent, getStudent } from "../controllers/studentController";
import { getStudentErrorMessage, normalizeStudentDetailsResponse } from "../utils/studentUtils";
import { getLmsRole, isParentRole } from "../../utils/lmsRole";
import StudentDetailPanel from "../components/StudentDetailPanel";
import { StudentsWrapper } from "../styles/StudentsStyle";

const StudentDetailsPage = () => {
  const [student, setStudent] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isDisabling, setIsDisabling] = useState(false);
  const [error, setError] = useState("");
  const { studentId } = useParams();
  const navigate = useNavigate();
  const { credObj } = useSelector((store) => store.auth);
  const { currentUser } = useSelector((store) => store.users);
  const role = getLmsRole({ currentUser, credObj });
  const isParent = isParentRole(role);

  useEffect(() => {
    let isMounted = true;

    const loadStudent = async () => {
      setIsLoading(true);
      setError("");
      try {
        const response = await getStudent(studentId);
        if (isMounted) setStudent(normalizeStudentDetailsResponse(response));
      } catch (err) {
        if (isMounted) setError(getStudentErrorMessage(err?.message));
      } finally {
        if (isMounted) setIsLoading(false);
      }
    };

    loadStudent();

    return () => {
      isMounted = false;
    };
  }, [studentId]);

  const handleDisable = async () => {
    setIsDisabling(true);
    setError("");
    try {
      await disableStudent(studentId);
      navigate("/dashboard/students", { replace: true });
    } catch (err) {
      setError(getStudentErrorMessage(err?.message));
    } finally {
      setIsDisabling(false);
    }
  };

  return (
    <StudentsWrapper>
      <div className="student-detail-actions">
        <Link to="/dashboard/students" className="student-secondary-action">
          {isParent ? "Back to kids" : "Back to students"}
        </Link>
        {student && (
          <Link to="/dashboard/reports" className="student-secondary-action">
            View Report
          </Link>
        )}
        {student && (
          <Link to={`/dashboard/students/${student.id}/edit`} className="lms-primary-action">
            {isParent ? "Edit Kid" : "Edit Student"}
          </Link>
        )}
      </div>

      {error && <p className="students-error" role="alert">{error}</p>}
      {isLoading && <p className="students-loading">{isParent ? "Loading kid details..." : "Loading student details..."}</p>}
      {!isLoading && student && (
        <>
          <StudentDetailPanel student={student} isParent={isParent} />
          <button
            type="button"
            className="student-danger-action"
            onClick={handleDisable}
            disabled={isDisabling}
          >
            {isDisabling ? "Disabling..." : isParent ? "Disable Kid" : "Disable Student"}
          </button>
        </>
      )}
    </StudentsWrapper>
  );
};

export default StudentDetailsPage;
